import React from 'react';
import {PropTypes} from 'prop-types';
import numeral from 'numeral';
import {BaseFormComponent} from '../../shared/baseFormComponent';
import {InfoItem} from '../AccountInfo/infoitem';
import {AccountComponent} from '../AccountsListComponent/account';
import {PageHeader} from '../../shared/PageHeader';
import {MakeApiCall, WriteConsoleErrors, GoBackOrRoot, GoToUrlOrRoot} from '../../shared/utils';

import './styles.scss';
import {ButtonBusyIndicatorComponent} from '../../shared/buttonBusyIndicatorComponent';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';

const ADDAGENTLIMIT_ACTION = {
    NONE: 0,
    SAVE: 1
}

export class AddAccountAgentLimitFormComponent extends BaseFormComponent {
    constructor(props, ...others) {
        super(props, ...others);

        this.state = {
            errors: null,
            action: ADDAGENTLIMIT_ACTION.NONE,
            formData: {
                MaxAgents: props.maxAgents,
            }
        }

        this._valueHandler.onChangeOptions = {
            'MaxAgents': {isNumber: true, precision: 0, min: props.maxAgents},
        }
        // this._valueHandler.onBlurOptions = {
        //     'TransactionId': {doLTrim: true, doRTrim: true},
        // }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.doSave = this.doSave.bind(this);
        this.doCancel = this.doCancel.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleSubmit(e) {
        e.preventDefault();
        this.doSave();
    }

    handleCancelClick() {
        this.doCancel();
    }

    doSave() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const {verificationToken, accountId, maxAgents} = self.props;
        const {formData} = self.state;

        const data = {
            AccountId: accountId,
            MaxAgents: formData.MaxAgents,
            MaxAgentsOld: maxAgents,
            AdminNotes: formData.AdminNotes
        }

        new Promise(resolve => {
            self.setState({action: ADDAGENTLIMIT_ACTION.SAVE}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.post(
                        {
                            url: '/api/admin/addAccountAgentLimit',
                            headers: {RequestVerificationToken: verificationToken},
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    )
                )
            }
            return null;
        })
        .then(responseData => self.doCancel(responseData.SuccessUrl))
        .catch(errors => {
            if (self._isMounted) {
                self.setState({action: ADDAGENTLIMIT_ACTION.NONE, errors: errors});
                WriteConsoleErrors(errors, true, true);
            }
        })
    }

    doCancel(url) {
        if (this._isMounted) {
            if (Boolean(url)) {
                GoToUrlOrRoot(url);
            }
            else {
                GoBackOrRoot();
            }
        }
    }

    render() {
        const self = this;

        const {maxAgents, basePrice, monthSize, summaryDiscountPercent, restDays, accountId, accountName, estimatedPrice} = self.props;
        const {action, formData, errors} = self.state;

        const isDisabled = action != ADDAGENTLIMIT_ACTION.NONE;

        const estimatedAmount = estimatedPrice * (formData.MaxAgents - maxAgents);

        return (
            <div>
                <PageHeader
                    fixed
                    captionTruncate
                    notWrappedMaxHeight={75}
                    caption={
                        <h2 className="text-truncate">Increase server limit</h2>
                    }
                />

                <div className="form-group">
                    <InfoItem caption="Account" content={<AccountComponent id={accountId} name={accountName} disabled={isDisabled} showId showLoginAs linkToInfo />} />
                </div>
                <div className="form-group">
                    <InfoItem caption="Month size, days" content={monthSize} />
                </div>
                <div className="form-group">
                    <InfoItem caption="Remaining subscription duration, days" content={restDays} />
                </div>
                <div className="form-group">
                    <InfoItem caption="Discount percent" content={summaryDiscountPercent} />
                </div>
                <div className="form-group">
                    <InfoItem caption="Base price" content={basePrice} />
                </div>
                <div className="form-group">
                    <InfoItem caption="Current limit" content={maxAgents} />
                </div>

                <form onSubmit={self.handleSubmit}>
                    <div className="row">
                        <div className="col-sm-8 col-md-6 col-lg-5 col-xl-4">
                            <div className="form-group newstyle mr-2">
                                <input
                                    id="MaxAgents"
                                    name="MaxAgents"
                                    type="number"
                                    className={self.getControlClass('MaxAgents', errors, 'form-control text-right')}
                                    disabled={isDisabled}
                                    value={formData.MaxAgents}
                                    onChange={self.handleInputChange}
                                    onBlur={self.handleInputChange}
                                    style={{width: '7.5em'}}
                                />
                                <label htmlFor="Amount"><span className="text-truncate">New limit</span></label>
                                <div className="invalid-feedback">{self.getControlError('MaxAgents', errors)}</div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <InfoItem caption="Estimated amount" content={numeral(estimatedAmount).USD()} />
                    </div>
                    <div className="row">
                        <div className="col-md-10 col-lg-7 col-xl-6">
                            <div className="form-group newstyle">
                                <textarea
                                    id="AdminNotes"
                                    name="AdminNotes"
                                    className="form-control mw-100"
                                    rows={3}
                                    disabled={isDisabled}
                                    value={formData.AdminNotes}
                                    onChange={self.handleInputChange}
                                />
                                <label htmlFor="AdminNotes"><span className="text-truncate">Notes</span></label>
                            </div>
                        </div>
                    </div>

                    <ErrorsBlockComponent errors={errors} excludedErrors="MaxAgents" unstyled />

                    <div className="form-buttons pt-3">
                        <button
                            type="submit"
                            disabled={isDisabled}
                            className="btn btn-sm btn-primary newstyle"
                        >
                            Increase limit
                            <ButtonBusyIndicatorComponent visible={action == ADDAGENTLIMIT_ACTION.SAVE} />
                        </button>
                        <button
                            type="button"
                            disabled={isDisabled}
                            className="btn btn-sm btn-outline-secondary newstyle"
                            onClick={self.handleCancelClick}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}
AddAccountAgentLimitFormComponent.propTypes = {
    accountId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    accountName: PropTypes.string.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    timeZoneName: PropTypes.string,
    maxAgents: PropTypes.number.isRequired,
    basePrice: PropTypes.number.isRequired,
    summaryDiscountPercent: PropTypes.number.isRequired,
    monthSize: PropTypes.number.isRequired,
    restDays: PropTypes.number.isRequired,
    estimatedPrice: PropTypes.number.isRequired
}